var _path, _g, _circle, _path2, _path3, _path4, _path5, _circle2, _path6, _circle3, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCounterIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: "64px",
    viewBox: "0 0 512 512",
    width: "64px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_802_",
    d: "m428.842 321.658c0 62.805-50.913 36.579-113.718 36.579s-113.718 26.226-113.718-36.579 50.913-113.718 113.718-113.718 113.718 50.914 113.718 113.718z",
    fill: "#6d81d5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5169cd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_803_",
    d: "m303.168 358.535c-57.189 2.701-101.76 21.884-101.76-36.872 0-32.388 13.545-61.611 35.264-82.33 37.757 27.038 63.27 70.126 66.496 119.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    d: "m428.843 321.663c0 40.253-20.915 43.933-52.478 41.376 17.781-2.422 28.574-12.452 28.574-41.376 0-58.766-44.572-107.121-101.76-113.089 3.927-.423 7.906-.629 11.947-.629 62.806.001 113.717 50.912 113.717 113.718z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_805_",
    d: "m422.895 285.266c-.32.01-.629.01-.948.01-34.758 0-65.631-16.895-84.866-42.892-6.968 2.072-14.328 3.206-21.956 3.206-21.616 0-41.18-8.968-55.148-23.389 16.328-9.092 35.13-14.256 55.148-14.256 50.076.001 92.597 32.368 107.77 77.321z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1170_",
    cx: 315.124,
    cy: 168.767,
    fill: "#8897dc",
    r: 61.363
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_807_",
    d: "m376.489 168.765c0 29.306-20.544 53.808-48.015 59.9-7.69-14.627-12.04-31.264-12.04-48.901 0-25.388 9.009-48.705 23.997-66.919 21.266 9.637 36.058 31.047 36.058 55.92z",
    fill: "#6d81d5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_809_",
    d: "m288.05 369.088c0 79.543-64.482 46.327-144.025 46.327s-144.025 33.216-144.025-46.327 64.482-144.025 144.025-144.025 144.025 64.482 144.025 144.025z",
    fill: "#64b9fc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_810_",
    d: "m210.097 241.096c-16.884 16.998-40.273 27.533-66.074 27.533s-49.19-10.545-66.064-27.543c19.791-10.236 42.252-16.019 66.064-16.019s46.283 5.783 66.074 16.029z",
    fill: "#31a7fb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_811_",
    d: "m288.046 369.09c0 49.282-24.76 55.282-62.518 52.694 23.956-2.484 38.624-14.771 38.624-52.694 0-75.516-58.127-137.457-132.076-143.528 3.938-.33 7.927-.495 11.947-.495 79.547 0 144.023 64.477 144.023 144.023z",
    fill: "#31a7fb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1163_",
    cx: 144.025,
    cy: 175.45,
    fill: "#8dcafc",
    r: 77.717
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_813_",
    d: "m221.745 175.455c0 42.912-34.8 77.712-77.722 77.712-4.123 0-8.164-.319-12.112-.938 37.171-5.814 65.61-37.985 65.61-76.774 0-38.799-28.44-70.971-65.61-76.784 3.948-.619 7.989-.938 12.112-.938 42.923 0 77.722 34.8 77.722 77.722z",
    fill: "#64b9fc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1158_",
    cx: 421.947,
    cy: 179.761,
    fill: "#ec6264",
    r: 90.053
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_815_",
    d: "m511.996 179.756c0 49.736-40.314 90.061-90.05 90.061-4.793 0-9.494-.371-14.081-1.103 43.036-6.752 75.96-44.015 75.96-88.958 0-44.932-32.924-82.196-75.96-88.948 4.587-.732 9.288-1.103 14.081-1.103 49.735 0 90.05 40.325 90.05 90.051z",
    fill: "#e64649"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_816_",
    d: "m438.953 212.058h-9.28v-72.321c0-4.267-3.459-7.726-7.726-7.726h-11.728c-4.267 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h4.002v64.595h-9.28c-4.267 0-7.726 3.459-7.726 7.726s3.459 7.726 7.726 7.726h34.013c4.267 0 7.726-3.459 7.726-7.726 0-4.266-3.46-7.726-7.727-7.726z",
    fill: "#eff5f6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterIcon1);
export default __webpack_public_path__ + "static/media/counter-icon-1.e6228c7ab827e14ec70f000c1b5ebacf.svg";
export { ForwardRef as ReactComponent };